module.exports = __webpack_public_path__ + "img/2d_Events.053d88c0.png";